import React from 'react';
import { DropdownListItem, useToasts } from '@brg/ui';
import useLocalization from '../../../../../hooks/useLocalization';
/**
 * **CommentsTooltip** - контент всплывающего меню для комментариев на канале
 * @param props
 */
export var CommentsTooltip = function (props) {
    var isEditable = props.isEditable, isDeletable = props.isDeletable, identifier = props.identifier, canAnswer = props.canAnswer, canReport = props.canReport, onAnswer = props.onAnswer, onReport = props.onReport, onEdit = props.onEdit, onDelete = props.onDelete, isBlackList = props.isBlackList, isWhiteList = props.isWhiteList, isPrivateChat = props.isPrivateChat, isChatClosed = props.isChatClosed;
    var t = useLocalization().t;
    var toasts = useToasts();
    var fireEvent = function (handler) { return function () {
        if (isBlackList) {
            return toasts.error(t('chat.errors.blacklist'));
        }
        if (!isWhiteList && isPrivateChat) {
            return toasts.error(t('chat.errors.whitelist'));
        }
        if (isChatClosed) {
            return toasts.error(t('chat.auth.default_msg_close'));
        }
        handler === null || handler === void 0 ? void 0 : handler(identifier !== null && identifier !== void 0 ? identifier : '');
    }; };
    return (React.createElement(React.Fragment, null,
        canAnswer && React.createElement(DropdownListItem, { onClick: fireEvent(onAnswer) }, t('chat.tooltip.answer').toLowerCase()),
        isEditable && React.createElement(DropdownListItem, { onClick: fireEvent(onEdit) }, t('chat.tooltip.edit').toLowerCase()),
        isDeletable && React.createElement(DropdownListItem, { onClick: fireEvent(onDelete) }, t('chat.tooltip.delete-comment').toLowerCase()),
        canReport && React.createElement(DropdownListItem, { onClick: fireEvent(onReport) }, t('chat.tooltip.report-comment').toLowerCase())));
};
//# sourceMappingURL=CommentsTooltip.js.mapimport React from 'react';
import { DropdownListItem, useToasts } from '@brg/ui';
import useLocalization from '../../../../../hooks/useLocalization';
/**
 * **CommentsTooltip** - контент всплывающего меню для комментариев на канале
 * @param props
 */
export var CommentsTooltip = function (props) {
    var isEditable = props.isEditable, isDeletable = props.isDeletable, identifier = props.identifier, canAnswer = props.canAnswer, canReport = props.canReport, onAnswer = props.onAnswer, onReport = props.onReport, onEdit = props.onEdit, onDelete = props.onDelete, isBlackList = props.isBlackList, isWhiteList = props.isWhiteList, isPrivateChat = props.isPrivateChat, isChatClosed = props.isChatClosed;
    var t = useLocalization().t;
    var toasts = useToasts();
    var fireEvent = function (handler) { return function () {
        if (isBlackList) {
            return toasts.error(t('chat.errors.blacklist'));
        }
        if (!isWhiteList && isPrivateChat) {
            return toasts.error(t('chat.errors.whitelist'));
        }
        if (isChatClosed) {
            return toasts.error(t('chat.auth.default_msg_close'));
        }
        handler === null || handler === void 0 ? void 0 : handler(identifier !== null && identifier !== void 0 ? identifier : '');
    }; };
    return (React.createElement(React.Fragment, null,
        canAnswer && React.createElement(DropdownListItem, { onClick: fireEvent(onAnswer) }, t('chat.tooltip.answer').toLowerCase()),
        isEditable && React.createElement(DropdownListItem, { onClick: fireEvent(onEdit) }, t('chat.tooltip.edit').toLowerCase()),
        isDeletable && React.createElement(DropdownListItem, { onClick: fireEvent(onDelete) }, t('chat.tooltip.delete-comment').toLowerCase()),
        canReport && React.createElement(DropdownListItem, { onClick: fireEvent(onReport) }, t('chat.tooltip.report-comment').toLowerCase())));
};
//# sourceMappingURL=CommentsTooltip.js.map